import {
  GET_PEGAWAI_ASN,
  GET_PEGAWAI_PJLP,
  GET_CREATE_ANAK,
  GET_CREATE_KELUARGA,
  GET_CREATE_BERKAS_ELEKTRONIK,
  GET_DETAIL_PEGAWAI_ASN,
  GET_LIST_KGB,
  GET_DATA_TUGAS_IZIN_BELAJAR,
  GET_LIST_HUKDIS,
  GET_LIST_DIKLAT_PERJENJANGAN,
  GET_LIST_PENYESUAIAN_IJAZAH,
  GET_DATA_PENGHARGAAN,
  GET_LIST_BAHASA,
  GET_PEGAWAI_KONTRAK,
  GET_LIST_PENDIDIKAN_FORMAL,
  GET_DATA_UJIAN_DINAS,
  GET_LIST_KEPANGKATAN,
  GET_DETAIL_PEGAWAI_ASN_POKOK,
  GET_DETAIL_PEGAWAI_PJLP,
  GET_DETAIL_PEGAWAI_KONTRAK,
  GET_LIST_PENDIDIKAN_INFORMAL,
  GET_CREATE_PASANGAN,
  GET_LIST_CLTN,
  GET_DIKLAT_PEGAWAI,
  GET_LIST_JABATAN,
  GET_PEGAWAI_JPT,
  GET_PEGAWAI_AKAN_PENSIUN,
  GET_OPTION_STATUS_PEGAWAI,
} from 'shared/constants/ActionTypes';

const placeholderDatas = {
  results: []
}

const placeholderData = {
  result: null,
}

const INIT_STATE = {
  listAsn: { ...placeholderData },
  listPjlp: { ...placeholderData },
  listKontrak: { ...placeholderData },
  listJpt: { ...placeholderData },
  detailPegawai: { ...placeholderData },
  dataKeluarga: {
    anak: { ...placeholderDatas },
    keluarga: { ...placeholderDatas },
    pasangan: { ...placeholderDatas },
  },
  dataLainnya: {
    pendidikanFormal: { ...placeholderDatas },
    pendidikanInformal: { ...placeholderDatas },
    diklatPerjenjangan: { ...placeholderDatas },
    kepangkatan: { ...placeholderDatas },
    jabatan: { ...placeholderDatas },
    penghargaan: { ...placeholderDatas },
    hukumanDisiplin: { ...placeholderDatas },
    cltn: { ...placeholderDatas },
    diklatPegawaiV2: { ...placeholderDatas }
  },
  dataAdministrasiKepeg: {
    kgb: { ...placeholderDatas },
    mutasi: { ...placeholderDatas },
    kp4: { ...placeholderDatas },
    ujianDinas: { ...placeholderDatas },
    akanPensiun: { ...placeholderDatas },
    penyesuaianIjazah: { ...placeholderDatas },
    tugasIzinBelajar: { ...placeholderDatas },
    kemampuanBahasaAsing: { ...placeholderDatas }
  },
  berkasElektronik: { ...placeholderDatas },
  statusPegawaiOption: { result: [] }
}

const dataPegawaiReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PEGAWAI_ASN: {
      return {
        ...state,
        listAsn: action.payload
      }
    }
    case GET_PEGAWAI_PJLP: {
      return {
        ...state,
        listPjlp: action.payload
      }
    }
    case GET_PEGAWAI_JPT: {
      return {
        ...state,
        listJpt: action.payload
      }
    }
    case GET_CREATE_ANAK: {
      return {
        ...state,
        dataKeluarga: {
          ...state.dataKeluarga,
          anak: action.payload
        }
      }
    }
    case GET_PEGAWAI_KONTRAK: {
      return {
        ...state,
        listKontrak: action.payload
      }
    }
    case GET_CREATE_KELUARGA: {
      return {
        ...state,
        dataKeluarga: {
          ...state.dataKeluarga,
          keluarga: action.payload
        }
      }
    }
    case GET_CREATE_PASANGAN: {
      return {
        ...state,
        dataKeluarga: {
          ...state.dataKeluarga,
          pasangan: action.payload
        }
      }
    }
    case GET_CREATE_BERKAS_ELEKTRONIK: {
      return {
        ...state,
        berkasElektronik: action.payload
      }
    }
    case GET_DETAIL_PEGAWAI_ASN: {
      return {
        ...state,
        detailPegawai: action.payload
      }
    }
    case GET_DETAIL_PEGAWAI_ASN_POKOK: {
      return {
        ...state,
        detailPegawai: action.payload
      }
    }
    case GET_DETAIL_PEGAWAI_PJLP: {
      return {
        ...state,
        detailPegawai: action.payload
      }
    }
    case GET_DETAIL_PEGAWAI_KONTRAK: {
      return {
        ...state,
        detailPegawai: action.payload
      }
    }
    case GET_LIST_KGB: {
      return {
        ...state,
        dataAdministrasiKepeg: {
          ...state.dataAdministrasiKepeg,
          kgb: action.payload
        }
      }
    }
    case GET_DATA_TUGAS_IZIN_BELAJAR: {
      return {
        ...state,
        dataAdministrasiKepeg: {
          ...state.dataAdministrasiKepeg,
          tugasIzinBelajar: action.payload
        }
      }
    }
    case GET_LIST_HUKDIS: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          hukumanDisiplin: action.payload
        }
      }
    }
    case GET_LIST_DIKLAT_PERJENJANGAN: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          diklatPerjenjangan: action.payload
        }
      }
    }
    case GET_LIST_PENYESUAIAN_IJAZAH: {
      return {
        ...state,
        dataAdministrasiKepeg: {
          ...state.dataAdministrasiKepeg,
          penyesuaianIjazah: action.payload
        }
      }
    }
    case GET_DATA_PENGHARGAAN: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          diklatPerjenjangan: action.payload,
          penghargaan: action.payload
        }
      }
    }
    case GET_LIST_BAHASA: {
      return {
        ...state,
        dataAdministrasiKepeg: {
          ...state.dataAdministrasiKepeg,
          kemampuanBahasaAsing: action.payload
        }
      }
    }
    case GET_LIST_PENDIDIKAN_FORMAL: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          pendidikanFormal: action.payload
        }
      }
    }
    case GET_DATA_UJIAN_DINAS: {
      return {
        ...state,
        dataAdministrasiKepeg: {
          ...state.dataAdministrasiKepeg,
          ujianDinas: action.payload
        }
      }
    }
    case GET_LIST_KEPANGKATAN: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          kepangkatan: action.payload
        }
      }
    }
    case GET_LIST_PENDIDIKAN_INFORMAL: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          pendidikanInformal: action.payload
        }
      }
    }
    case GET_LIST_CLTN: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          cltn: action.payload
        }
      }
    }
    case GET_DIKLAT_PEGAWAI: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          diklatPegawaiV2: action.payload
        }
      }
    }
    case GET_LIST_JABATAN: {
      return {
        ...state,
        dataLainnya: {
          ...state.dataLainnya,
          jabatan: action.payload
        }
      }
    }
    case GET_PEGAWAI_AKAN_PENSIUN: {
      return {
        ...state,
        dataAdministrasiKepeg: {
          ...state.dataAdministrasiKepeg,
          akanPensiun: action.payload
        }
      }
    }
    case GET_OPTION_STATUS_PEGAWAI: {
      const tmpOption = action.payload?.result.map((item) => ({ id: item?.key, label: item?.nama }))
      return {
        ...state,
        statusPegawaiOption: {
          result: tmpOption
        }
      }
    }
    default:
      return state;
  }
};
export default dataPegawaiReducer;
